import * as types from '../actions/types';

const initialState = {
    data: [],
    loading: false,
    hasMore: true,
    pageIndex: 0,
    cancelVoucher: {
        error: null,
        loading: false,
    },
    voucherModal: {
        isVisible: false,
        voucherCode: null,
        loading: false,
        voucher: null,
    },
};

export default function (state = initialState, action) {
    const { type, payload, hasMore } = action;

    switch (type) {
        case types.GET_VOUCHERS_REQUEST:
            return { ...state, loading: true };
        case types.GET_VOUCHERS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload,
                hasMore,
            };
        case types.VOUCHER_MODAL_PROPS_CHANGED:
            return {
                ...state,
                voucherModal: {
                    ...state.voucherModal,
                    ...payload,
                },
            };
        case types.VOUCHER_MODAL_PROPS_RESET:
            return {
                ...state,
                voucherModal: initialState.voucherModal,
            };
        case types.SET_VOUCHERS:
            return {
                ...state,
                data: payload,
            };
        case types.CLEAR_VOUCHERS:
            return { ...state, data: [] };
        case types.CLEAR_VOUCHER:
            return {
                ...state,
                voucherModal: initialState.voucherModal,
                cancelVoucher: initialState.cancelVoucher,
            };
        case types.CANCEL_VOUCHER_REQUEST:
            return {
                ...state,
                cancelVoucher: payload,
            };

        default:
            return state;
    }
}
